// extracted by css-extract-rspack-plugin
export default {"icon":"EntityCell_icon__Pya4A","main":"EntityCell_main__YimbA","iconDiv":"EntityCell_iconDiv__rRauc"};